module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-391.5fe5f5f.woff2";